export default {
  api: new API({
    rootdir: 'http://www.d-63.com.cn/', // 设置项目根目录，也可以是：'http://demo.yfd.com.cn/case'
    database: 'access' // 设置项目数据库类型，'access' or 'sql', 不设置则默认为'access'
  }),
  options: {
    categoryId: 1, // 分类ID, 必须
    pageIndex: 1, // 当前页码
    pageSize: 0, // 请求数量
    title_en: 1, // 英文标题
    sub_title: 1, // 副标题
    big_img: 1, // 大图路径
    bigsmall: 1,//大小图判断
    video_src: 1, // 视频路径
    filter: '' // 可选值：'推荐' | '热门' | '置顶'
  },
  imgLoaded(arr) {
    return new Promise(function (resolve, reject) {
      if (arr.length === 0) reject();
      let imgsArr = [], c = 0, l = arr.length, o, params;
      arr.forEach(function (src) {
        o = new Image();
        o.addEventListener('load', function () {
          ++c === l && resolve(imgsArr);
        }, false);
        o.addEventListener('error', function () {
          ++c === l && reject();
        }, false);
        if (src.data) {
          params = src.data[0].img_url || src.data[0].original_path || src.data[0].big_img;
        } else {
          params = src.img_url || src.original_path || src.big_img;
        }
        o.src = params;
        imgsArr.push(o);
      });
    });
  },
  mobile() {
    const ua = navigator.userAgent;
    const ipad = ua.match(/(iPad).*OS\s([\d_]+)/),
      isIphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/),
      isAndroid = ua.match(/(Android)\s+([\d.]+)/);
    return isIphone || isAndroid || ipad;
  },
  parents(e, el) {
    let eTarget = e.parentNode;
    if (eTarget.nodeName.toLowerCase() === el.toLowerCase()) {
      return eTarget;
    } else if (eTarget.nodeName.toLowerCase() === 'body') {
      return "";
    }
    return this.parents(eTarget, el)
  },
  assign(oldObj, newObj) {
    return Object.assign({}, oldObj, newObj);
  },
  assigns(oldObj, newObj) {
    if (!oldObj) {
      return
    }
    return Object.assign(oldObj, newObj);
  },
  scrollTop() {
    return document.documentElement.scrollTop || document.body.scrollTop;
  },
  splitArray(array, size) {
    var n = array.length, i = 0, result = [];
    for (; i < n; i += size) {
      result.push(array.slice(i, i + size));
    }
    return result;
  },
  shuffle(arr) {
   return arr.sort(() => Math.random() - 0.5);
  },
  prefixStyle(style) {

    let elementStyle = document.createElement('div').style

    let vendor = (() => {
      let transformNames = {
        webkit: 'webkitTransform',
        Moz: 'MozTransform',
        O: 'OTransform',
        ms: 'msTransform',
        standard: 'transform'
      }

      for (let key in transformNames) {
        if (elementStyle[transformNames[key]] !== undefined) {
          return key
        }
      }

      return false
    })()

    if (vendor === false) {
      return false
    }

    if (vendor === 'standard') {
      return style
    }

    return vendor + style.charAt(0).toUpperCase() + style.substr(1)
  }
}





// WEBPACK FOOTER //
// ./src/common/api/yfdCommon.js